import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayNum, propArrayShape, propBool, propFunc, } from '../../../../helpers/custom-prop-types';
import SearchFilterItems from './Common/SearchFilterItems';
const SearchFilterIndustriesBody = (props) => {
    const { inputIndustries, isShow, onChangeInputFilter, viewIndustries } = props;
    return (_jsx("div", Object.assign({ className: `search_list_filter_body ${isShow ? '' : 'is-dnone'}` }, { children: _jsx(SearchFilterItems, { inputItems: inputIndustries, inputName: 'industry', onChangeInputFilter: onChangeInputFilter, viewItems: viewIndustries }) })));
};
SearchFilterIndustriesBody.propTypes = {
    inputIndustries: propArrayNum().isRequired,
    isShow: propBool().isRequired,
    onChangeInputFilter: propFunc().isRequired,
    viewIndustries: propArrayShape().isRequired,
};
export default SearchFilterIndustriesBody;
